import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "user";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //获取负责人;(基地/塘口)
    async getCompanyUser() {
      let result = await api.get("/api/User?");
      return result.data;
    },
    // 获取当前公司下的员工列表
    async getEmployees() {
      let result = await api.get("/api/User/GetEmployees");
      return result.data;
    },
    // 获取当前基地下的负责人员工列表
    async getEmployeesByFishBase({ commit }, payload) {
      let result = await api.get("/api/User/GetEmployeesByFishBase?fishBaseId=" + payload);
      return result.data;
    },
    //选择版本
    async selectB(a, payload) {
      let result = await api.put(
        `/api/Enterprise/EnterpriseVersion/${payload.isqlw}`,
        payload.data
      );
      store.commit("setQlw", payload.isqlw);
      return result.data;
    },
    //公司设置-获取数据
    async getCompanySettingData() {
      let result = await api.get("/api/Enterprise/CurrentEnterpriseToPC");
      return result.data;
    },
    //更新公司设置
    async addCompanySetting({ commit }, payload) {
      console.log(888, payload);
      let result = await api.put(
        `/api/Enterprise/UpdateEnterprise?${queryString.stringify(payload)}`
      );
      return result;
    },
    //进入演示渔场
    async getYanShiFishery() {
      let result = await api.get("/api/Account/DemoLogin");
      return result.data;
    },
    //获取平台下所有设备列表
    async getPlatformEquipmentList({ commit }, payload) {
      let result = await api.get(
        `/api/Equipment/GetPlatformEquipmentList?${queryString.stringify(
          payload
        )}`
      );
      return result.data;
    }
  }
});

export default moduleName;
